import PropTypes from 'prop-types';

export { default as withConfig } from './withConfig';
export { default as useConfig } from './useConfig';
export { Context as ConfigContext, Provider as ConfigProvider } from './configContext';

export const featureFlagsPropTypeShape = PropTypes.shape({
  ADMIN_ACCOUNTS_FLOW: PropTypes.bool,
  ADMIN_ACCOUNTS_FLOW_TO_FUNNEL_4_ECOSYSTEM: PropTypes.bool,
  CASH_INSTALLMENTS: PropTypes.bool,
  DESIGN_SYSTEM_VERSION: PropTypes.bool,
  INSTALLMENTS_WITH_CHARGE: PropTypes.bool,
  MULTI_PRODUCT: PropTypes.bool,
});

export const featureFlagsProvidersPropTypeShape = PropTypes.object;

export const featureActionsPropTypeShape = PropTypes.shape({
  refreshFeatureFlags: PropTypes.func.isRequired,
});
